const errorCodes = {
  dependsOnItself: 1,
  invalidExpression: 2,
  isNotAssignment: 3
};
export {
  errorCodes
};
